import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ConfirmationAmount from './ConfirmationAmount';
import ConfirmationAmountGiftAid from './ConfirmationAmountGiftAid';

const ConfirmationMessage = ({
  yourDonation,
  giftaidFlag,
  extraDonateAmount,
  giftAid,
}) => {
  useEffect(() => {
    const confirmationHeader = document.getElementsByClassName(
      'confirmation_header'
    );
    confirmationHeader[0].focus();
  }, []);

  return (
    <div className="confirmation_header" role="text" tabIndex="-1">
      <ConfirmationAmount message={yourDonation} />
      {giftaidFlag && (
        <ConfirmationAmountGiftAid
          extraDonateAmount={extraDonateAmount}
          giftAid={giftAid}
        />
      )}
    </div>
  );
};

ConfirmationMessage.propTypes = {
  yourDonation: PropTypes.object,
  giftaidFlag: PropTypes.bool,
  extraDonateAmount: PropTypes.string,
  giftAid: PropTypes.string,
};

export default ConfirmationMessage;
